var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoctorShapesDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124.08957mm",
    height: "199.76042mm",
    viewBox: "0 0 124.08956 199.76042",
    id: "svg424",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs421"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-230.60223,-29.6558)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -354.6918,
    y: -229.41621,
    width: 47.095833,
    height: 87.047913,
    rx: 23.547916,
    transform: "scale(-1)",
    fill: "#004aad",
    id: "rect66",
    style: {
      strokeWidth: 0.264583
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorShapesDark);
export default __webpack_public_path__ + "static/media/doctor_shapes_dark.d8d96a68c2dbb8376b4ece05140d99f1.svg";
export { ForwardRef as ReactComponent };